import React from 'react';
import { Stack } from '@mui/material';
import { VButton, VTypography } from '@venti-components';
import PageContainer from '../../../../Components/PageContainer/PageContainer';
import { useModoCheckout } from './hook';

const ModoCheckout = () => {
  const { isLoading, shouldShowError } = useModoCheckout();

  return (
    <PageContainer withFooter withPaddingTop={false} title="Modo Checkout">
      <Stack gap={2} alignItems="center" justifyContent="center" mt={10}>
        <VTypography variant="h4">Pagar con Modo</VTypography>
        {isLoading && <VTypography variant="body1">Cargando el pago...</VTypography>}
        {shouldShowError && <VTypography variant="body1">Error al crear el pago</VTypography>}
        {!isLoading && <VButton href="/eventos" label="Volver al inicio" />}
      </Stack>
    </PageContainer>
  );
};

export default ModoCheckout;
